/* wlt-motion.js — motorul comun al secțiunilor wlt-* (Orbea Wild LT „WOW”, 24 oct 2026). Fără biblioteci; se încarcă cu defer
   din fiecare secțiune, rulează o singură dată (window.WLT). Ce face:
   · intrări declanșate (.wlt-rv / .wlt-r2 / .wlt-bar): .is-wait doar pe ce e sub ecran la inițializare, .is-in la intrare;
   · rezerva scenelor (fără animation-timeline sau ?wlt=io): scrie --p pe [data-tl] (contain / exit / cover), aceleași keyframes din CSS;
   · video: sursa pusă la un ecran distanță (sau după load pentru [data-eager]), pornit la ≥ 30 % vizibil, oprit la ieșire / tab ascuns;
     cu reduced-motion, saveData sau 2g rămâne posterul (.is-still); butonul de pauză apare la „playing”;
   · cifre care numără (o dată), sub-meniul fix (apare după hero, tema urmează banda de dedesubt), săgețile caruselelor.
   Runda 2: plafonul scării literelor 24 / 16 (telefon), întârzierea cardurilor după rândul vizual.
   Runda 3: taburile capitolului Avinox ([data-wlt-tabs]: role=tab, săgeți / Home / End, pastila care alunecă, panoul activ .is-on). */
(function () {
  if (window.WLT) return;
  var W = window.WLT = { v: 1 };
  var d = document, de = d.documentElement;
  var mm = function (q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } };
  var RM = mm('(prefers-reduced-motion: reduce)');
  var con = navigator.connection || {};
  var SLOW = !!(con.saveData || /(^|-)2g$/.test(con.effectiveType || ''));
  var IO = 'IntersectionObserver' in window;
  var SDA = de.classList.contains('wlt-sda');
  if (!RM && !SDA && IO) de.classList.add('wlt-io');
  W.RM = RM; W.SLOW = SLOW;
  var clamp = function (x) { return x < 0 ? 0 : x > 1 ? 1 : x; };
  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };
  var all = function (s, r) { return [].slice.call((r || d).querySelectorAll(s)); };

  /* ---------- cifre ---------- */
  function countUp(el) {
    if (RM || el.__c) return; el.__c = 1;
    var to = parseFloat(el.getAttribute('data-count')), node = el.firstChild;
    if (!node || node.nodeType !== 3 || isNaN(to)) return;
    el.style.minWidth = el.getBoundingClientRect().width + 'px';
    var t0 = 0, D = 1200, fin = node.nodeValue;
    var ease = function (x) { return x >= 1 ? 1 : 1 - Math.pow(2, -10 * x); };
    node.nodeValue = '0';
    (function f(t) { if (!t0) t0 = t; var k = Math.min(1, (t - t0) / D); node.nodeValue = k >= 1 ? fin : String(Math.round(to * ease(k))); if (k < 1) raf(f); })(0);
  }

  /* ---------- intrări ---------- */
  var rio = IO && !RM ? new IntersectionObserver(function (es) {
    es.forEach(function (x) {
      if (!x.isIntersecting) return;
      var e = x.target; e.classList.add('is-in'); e.classList.remove('is-wait'); rio.unobserve(e);
      all('[data-count]', e).forEach(countUp);
    });
  }, { rootMargin: '0px 0px -12% 0px' }) : null;
  W.reveal = function (els) {
    var vh = window.innerHeight;
    els.forEach(function (e) {
      if (e.__r) return; e.__r = 1;
      if (!rio) return;
      var r = e.getBoundingClientRect();
      if (r.top < vh * 0.92 || r.bottom <= 0) return;
      e.classList.add('is-wait'); rio.observe(e);
    });
  };

  /* ---------- rezerva scenelor (--p) ---------- */
  var act = [], tick = false, sio = null;
  function prog(e) {
    var r = e.getBoundingClientRect(), vh = window.innerHeight, t = e.getAttribute('data-tl');
    if (t === 'exit') return clamp(-r.top / Math.max(1, r.height));
    if (t === 'cover') return clamp((vh - r.top) / (vh + r.height));
    return clamp(-r.top / Math.max(1, r.height - vh));
  }
  function upd() { tick = false; var ps = act.map(prog); act.forEach(function (e, i) { e.style.setProperty('--p', ps[i].toFixed(4)); }); }
  function req() { if (!tick) { tick = true; raf(upd); } }
  function scenes() {
    if (!de.classList.contains('wlt-io')) return;
    if (!sio) {
      sio = new IntersectionObserver(function (es) { es.forEach(function (x) { var i = act.indexOf(x.target); if (x.isIntersecting && i < 0) act.push(x.target); if (!x.isIntersecting && i > -1) { act.splice(i, 1); x.target.style.setProperty('--p', prog(x.target).toFixed(4)); } }); req(); }, { rootMargin: '10% 0px' });
      window.addEventListener('scroll', req, { passive: true }); window.addEventListener('resize', req);
    }
    all('[data-tl]').forEach(function (e) { if (e.__t) return; e.__t = 1; e.style.setProperty('--p', prog(e).toFixed(4)); sio.observe(e); });
  }

  /* ---------- video ---------- */
  var vids = [];
  function vplay(o) {
    var v = o.v;
    if (o.want && !o.user && o.ready && !d.hidden) {
      if (!o.src) { o.src = 1; v.src = (window.innerWidth < 750 && v.getAttribute('data-src-s')) || v.getAttribute('data-src-l'); }
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    } else if (!v.paused) v.pause();
  }
  function videos() {
    all('video[data-wlt-v]').forEach(function (v) {
      if (v.__v) return; v.__v = 1;
      var box = v.closest('[data-wlt-vbox]') || v.parentNode, btn = box.querySelector('[data-wlt-pp]');
      if (RM || SLOW || !IO) { box.classList.add('is-still'); return; }
      var o = { v: v, box: box, want: false, user: false, ready: !v.hasAttribute('data-eager'), src: 0 };
      vids.push(o);
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      v.addEventListener('playing', function () { box.classList.add('is-on'); if (btn) btn.hidden = false; });
      if (btn) btn.addEventListener('click', function () {
        o.user = !o.user; btn.classList.toggle('is-paused', o.user);
        btn.setAttribute('aria-label', o.user ? 'Pornește videoclipul' : 'Oprește videoclipul'); vplay(o);
      });
      if (!o.ready) {
        var go = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 250); })(function () { o.ready = true; vplay(o); }, { timeout: 1500 }); };
        if (d.readyState === 'complete') go(); else window.addEventListener('load', go, { once: true });
      } else {
        var nio = new IntersectionObserver(function (es) { if (es[0].isIntersecting && !o.src) { o.src = 1; v.src = (window.innerWidth < 750 && v.getAttribute('data-src-s')) || v.getAttribute('data-src-l'); v.preload = 'auto'; nio.disconnect(); } }, { rootMargin: '100% 0px' });
        nio.observe(box);
      }
      new IntersectionObserver(function (es) { var x = es[0]; o.want = x.isIntersecting && x.intersectionRatio >= 0.3; vplay(o); }, { threshold: [0, 0.3, 0.6] }).observe(box);
    });
  }
  d.addEventListener('visibilitychange', function () { vids.forEach(vplay); });

  /* ---------- sub-meniul fix ---------- */
  function nav() {
    var n = d.querySelector('[data-wlt-nav]'); if (!n || n.__n) return; n.__n = 1;
    var hero = d.querySelector('[data-wlt-hero]'), tg = n.querySelector('[data-wlt-navt]');
    var secs = all('#MainContent > .shopify-section, main > .shopify-section');
    var links = all('a[href^="#"]', n).filter(function (a) { return a.getAttribute('href').length > 1 && !a.hasAttribute('data-cta'); });
    var tgts = links.map(function (a) { return d.getElementById(a.getAttribute('href').slice(1)); });
    var lastWlt = all('.wlt[data-wlt-band]').pop();
    var shown = null, band = null, cur = -1, t = false;
    if (tg) tg.addEventListener('click', function () { var o = n.classList.toggle('is-open'); tg.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    links.forEach(function (a) { a.addEventListener('click', function () { n.classList.remove('is-open'); if (tg) tg.setAttribute('aria-expanded', 'false'); }); });
    function bandAt(y) {
      for (var i = 0; i < secs.length; i++) {
        var r = secs[i].getBoundingClientRect();
        if (r.top <= y && r.bottom > y) {
          var b = secs[i].querySelector('[data-wlt-band]');
          if (b) { var rb = b.getBoundingClientRect(); if (rb.top <= y && rb.bottom > y) return b.hasAttribute('data-wlt-band-at') ? bandIn(b, y) : b.getAttribute('data-wlt-band'); }
          return 'luminos';
        }
      }
      return 'luminos';
    }
    function bandIn(b, y) { var kids = all('[data-wlt-sub]', b); for (var i = 0; i < kids.length; i++) { var r = kids[i].getBoundingClientRect(); if (r.top <= y && r.bottom > y) return kids[i].getAttribute('data-wlt-sub'); } return b.getAttribute('data-wlt-band'); }
    function upd() {
      t = false;
      var vh = window.innerHeight, hb = hero ? hero.getBoundingClientRect() : null;
      var on = hb ? hb.bottom < hb.height * 0.3 : true;
      if (lastWlt) { var lr = lastWlt.getBoundingClientRect(); if (lr.bottom < vh * 0.55) on = false; }
      if (on !== shown) { shown = on; n.classList.toggle('is-shown', on); n.setAttribute('aria-hidden', on ? 'false' : 'true'); if (!on) { n.classList.remove('is-open'); if (tg) tg.setAttribute('aria-expanded', 'false'); } all('a,button', n).forEach(function (x) { x.tabIndex = on ? 0 : -1; }); }
      var nb = n.querySelector('.wlt-nav__bar'), y = (parseFloat(getComputedStyle(n).top) || 8) + (nb ? nb.offsetHeight / 2 : 26);
      var b = bandAt(y); if (b !== band) { band = b; n.classList.toggle('is-light', b === 'luminos'); }
      var c = -1; tgts.forEach(function (el, i) { if (el && el.getBoundingClientRect().top < vh * 0.35) c = i; });
      if (c !== cur) { cur = c; links.forEach(function (a, i) { if (i === c) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current'); }); }
    }
    var req2 = function () { if (!t) { t = true; raf(upd); } };
    window.addEventListener('scroll', req2, { passive: true }); window.addEventListener('resize', req2); upd();
  }

  /* ---------- carusele ---------- */
  function cars() {
    all('[data-wlt-car]').forEach(function (c) {
      if (c.__k) return; c.__k = 1;
      var sc = c.querySelector('.wlt-car__sc'), pv = c.querySelector('[data-car-prev]'), nx = c.querySelector('[data-car-next]');
      if (!sc) return;
      var step = function () { var it = sc.children[0]; return it ? it.getBoundingClientRect().width + 20 : sc.clientWidth * 0.8; };
      var st = function () { if (pv) pv.disabled = sc.scrollLeft < 4; if (nx) nx.disabled = sc.scrollLeft + sc.clientWidth > sc.scrollWidth - 4; };
      if (pv) pv.addEventListener('click', function () { sc.scrollBy({ left: -step(), behavior: RM ? 'auto' : 'smooth' }); });
      if (nx) nx.addEventListener('click', function () { sc.scrollBy({ left: step(), behavior: RM ? 'auto' : 'smooth' }); });
      sc.addEventListener('scroll', function () { raf(st); }, { passive: true }); window.addEventListener('resize', st); st();
    });
  }

  /* ---------- taburi (capitolul Avinox) ---------- */
  function tabs() {
    all('[data-wlt-tabs]').forEach(function (w) {
      if (w.__tb) return; w.__tb = 1;
      var bar = w.querySelector('[role="tablist"]'), ts = all('[role="tab"]', w), ps = all('[role="tabpanel"]', w), ind = w.querySelector('.wlt-tb__ind'), cur = 0;
      if (!bar || !ts.length) return;
      ts.forEach(function (t, i) { if (t.getAttribute('aria-selected') === 'true') cur = i; });
      function place() { var t = ts[cur]; if (!ind || !t) return; ind.style.setProperty('--x', t.offsetLeft + 'px'); ind.style.setProperty('--w', t.offsetWidth + 'px'); }
      function sel(i, focus) {
        cur = i;
        ts.forEach(function (t, k) { var on = k === i; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; });
        ps.forEach(function (p) { p.classList.toggle('is-on', p.id === ts[i].getAttribute('aria-controls')); });
        place();
        if (focus) ts[i].focus({ preventScroll: true });
        if (bar.scrollWidth > bar.clientWidth + 2) { var t = ts[i]; bar.scrollTo({ left: t.offsetLeft - (bar.clientWidth - t.offsetWidth) / 2, behavior: RM ? 'auto' : 'smooth' }); }
      }
      ts.forEach(function (t, i) {
        t.addEventListener('click', function () { sel(i); });
        t.addEventListener('keydown', function (e) {
          var n = ts.length, j = -1;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % n; else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + n) % n; else if (e.key === 'Home') j = 0; else if (e.key === 'End') j = n - 1;
          if (j > -1) { e.preventDefault(); sel(j, true); }
        });
      });
      place(); w.classList.add('is-js');
      window.addEventListener('resize', function () { raf(place); });
      if (d.fonts && d.fonts.ready) d.fonts.ready.then(place);
    });
  }

  /* ---------- literele: originea zoom-ului în litera marcată + plafonul scării ---------- */
  function fit() {
    all('[data-origin]').forEach(function (w) {
      var o = w.querySelector('[data-o]'); if (!o) return;
      w.style.transformOrigin = (o.offsetLeft + o.offsetWidth / 2) + 'px ' + (o.offsetTop + o.offsetHeight * 0.55) + 'px';
      var cap = window.innerWidth < 750 ? 16 : 24;
      w.style.setProperty('--zmax', Math.min(cap, Math.ceil(Math.max(window.innerWidth, window.innerHeight) * 2.2 / Math.max(4, o.offsetWidth * 0.6))));
    });
  }

  function init() {
    W.reveal(all('.wlt-rv,.wlt-r2,.wlt-bar'));
    scenes(); videos(); nav(); cars(); fit(); tabs();
    var hf = d.querySelector('[data-wlt-grid]');
    /* runda 2: întârzierea cardurilor după poziția în rândul VIZUAL (cardul lat e singur pe rândul lui; pe telefon 0 / 1), nu i % 3 */
    if (hf) { var g = d.getElementById(hf.getAttribute('data-wlt-grid')); if (g) { var cs = all('.pcb-card', g); cs.forEach(function (c) { var t = c.offsetTop, l = c.offsetLeft, k = 0; cs.forEach(function (o) { if (o !== c && Math.abs(o.offsetTop - t) < 2 && o.offsetLeft < l) k++; }); c.style.setProperty('--i', k); }); W.reveal(cs); } }
  }
  W.init = init;
  init();
  if (d.fonts && d.fonts.ready) d.fonts.ready.then(fit);
  window.addEventListener('resize', function () { raf(fit); });
  d.addEventListener('shopify:section:load', function () { setTimeout(init, 0); });
})();
